<mat-card>
  <h1>Logout Successful</h1>
  <h3>You have been successfully logged out of the Application.</h3>
</mat-card>
